"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stellaswap = void 0;
exports.stellaswap = {
    routerV1: '0xd0A01ec574D1fC6652eDF79cb2F880fd47D34Ab1',
    router: '0x70085a09D30D6f8C4ecF6eE10120d1847383BB57',
    masterchef: '0xEDFB330F5FA216C9D2039B99C8cE9dA85Ea91c1E',
    masterchefV1distributorV2: '0xF3a5454496E26ac57da879bf3285Fa85DEBF0388',
};
